import {
    collection,
    deleteDoc,
    doc,
    getDocs,
    setDoc,
    updateDoc,
} from 'firebase/firestore';
import { db } from '@/config/firebase';

export interface CompanySettings {
    id: string;
    startDate: string; // YYYY-MM
    regime: 'SIMPLES' | 'LUCRO_PRESUMIDO' | 'LUCRO_REAL';
    inssEmployerRate: number; // % (Standard 20, LeidoBem 15, Desonerado/Simples 0)
    rat: number; // %
    fap: number; // Multiplier
    thirdParties: number; // %
    cprbRate: number; // % (For Desonerados paying on Revenue)
}

const COLLECTION = 'company_settings';

export const companySettingsService = {
    getAll: async (): Promise<CompanySettings[]> => {
        const snap = await getDocs(collection(db, COLLECTION));
        const data = snap.docs.map(d => ({ ...(d.data() as any), id: d.id }));
        // Sort desc by date
        return data.sort((a, b) => b.startDate.localeCompare(a.startDate));
    },

    create: async (data: Omit<CompanySettings, 'id'>): Promise<CompanySettings> => {
        const newRef = doc(collection(db, COLLECTION));
        // Use ID as ref id
        const payload = { ...data, id: newRef.id };
        await setDoc(newRef, payload);
        return payload;
    },

    update: async (id: string, data: Partial<CompanySettings>): Promise<CompanySettings> => {
        const ref = doc(db, COLLECTION, id);
        await updateDoc(ref, data);
        return { id, ...data } as CompanySettings; // optimistically return merged? Actually better to re-fetch if critical, but standard pattern ok
    },

    delete: async (id: string): Promise<void> => {
        await deleteDoc(doc(db, COLLECTION, id));
    },

    getSettingsForDate: async (date: string): Promise<CompanySettings | null> => {
        // Client-side filtering for simplicity given low volume of settings history
        const all = await companySettingsService.getAll();
        // Sort descending
        const sorted = all.sort((a, b) => b.startDate.localeCompare(a.startDate));
        const match = sorted.find(s => s.startDate <= date);
        return match || null;
    }
};
